@let isLoading = loading();

<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" data-testid="asset-recovery">
  <div class="flex mb-2 gap-2 items-end">
    <app-pan-form-control>
      <app-pan-floating-label>Case Date From</app-pan-floating-label>
      <app-pan-datepicker
        [(date)]="caseDateFrom"
        [min]="caseDateFromMin()"
        [max]="caseDateTo()"
        [disabled]="isLoading"
        (dateChange)="load()"
        placeholder="Case date from"
        data-testid="ar-date-from"
      ></app-pan-datepicker>
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>Case Date To</app-pan-floating-label>
      <app-pan-datepicker
        [(date)]="caseDateTo"
        [min]="caseDateFrom()"
        [max]="caseDateToMax()"
        [disabled]="isLoading"
        (dateChange)="load()"
        placeholder="Case date to"
        data-testid="ar-date-to"
      ></app-pan-datepicker>
    </app-pan-form-control>

    <app-pan-button
      color="primary"
      [swal]="createArReportSwal"
      [disabled]="!canCreateReport()"
      [state]="creatingReport() ? 'loading' : 'default'"
      data-testid="create-ar-report-button"
    >
      Create AR Report
    </app-pan-button>
  </div>

  @if (isLoading) {
    <app-pan-blank-slate>
      <app-pan-spinner></app-pan-spinner>
      <span>Loading cases...</span>
    </app-pan-blank-slate>
  } @else {
    <ag-grid-angular
      [rowData]="cases()"
      [columnDefs]="columnDefs"
      [gridOptions]="tableDef"
      data-testid="ar-grid"
    ></ag-grid-angular>
  }
</app-pan-card>

<app-pan-modal #arSummaryModal [topLevel]="false" size="md">
  <div header>AR Summary</div>
  <div body class="flex flex-col gap-3 max-h-[400px] overflow-y-auto">
    @if (arSummaryLoading()) {
      <app-pan-blank-slate>
        <app-pan-spinner></app-pan-spinner>
        <span>Loading summary...</span>
      </app-pan-blank-slate>
    } @else if (arSummaryReports().length === 0) {
      <app-pan-blank-slate>No AR report has been submitted for this case yet.</app-pan-blank-slate>
    } @else {
      @for (report of arSummaryReports(); track report.asset_recovery_id) {
        <app-pan-card data-testid="ar-summary-report-card">
          <div class="font-bold">{{ report.asset_recovery_id }}</div>
          <div class="grid grid-cols-2 gap-2">
            <div>
              <div class="flex gap-2" data-testid="ar-summary-incident-count">
                <strong>Incidents Included:</strong> {{ report.incident_count }}
              </div>
              <div class="flex gap-2">
                <strong>Base Value:</strong> {{ report.amount | currency: "USD" }}
              </div>
              <div class="flex gap-2" data-testid="ar-summary-added-fees">
                <strong>Added Fees:</strong> {{ report.added_fees | currency: "USD" }}
              </div>
            </div>
            <div>
              <div class="flex gap-2">
                <strong>Total Amount:</strong> {{ report.amount + report.added_fees | currency: "USD" }}
              </div>
              <div class="flex gap-2">
                <strong>Date Shared:</strong> {{ report.created_at | date: "mediumDate" }}
              </div>
              <div class="flex gap-2" data-testid="ar-summary-status">
                <strong>Status:</strong>
                <app-pan-chip [color]="report.status === 'Paid' ? 'success' : 'danger'" size="sm">{{ report.status }}</app-pan-chip>
              </div>
            </div>
          </div>
        </app-pan-card>
      }
    }
  </div>
  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Cancel</app-pan-button>
  </div>
</app-pan-modal>

<swal
  #createArReportSwal
  title="Create Asset Recovery Report"
  text="What would you like to name the report for your selected incidents?"
  icon="question"
  confirmButtonText="Create Report"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="createReport($event)"
  input="text"
  [inputAttributes]="{ minlength: '4', maxlength: '25' }"
  [inputValidator]="reportNameValidate"
>
</swal>
